<template>
  <div>
    <div class="title is-4">Appointment Scheduler</div>

    <div class="columns">
      <div class="column is-half">
        <p>
          <input
            class="input is-medium"
            placeholder="Search name or description"
            v-model="filterString"
          />
        </p>
      </div>
    </div>

    <div class="columns mt-4">
      <div class="column is-half">
        <company-card
          v-for="suite in columnOne"
          :key="suite.id"
          :suite="suite"
        ></company-card>
      </div>
      <div class="column is-half">
        <company-card
          v-for="suite in columnTwo"
          :key="suite.id"
          :suite="suite"
        ></company-card>
      </div>
    </div>
  </div>
</template>

<script>
import ExhibitorSchedule from '@/components/shared/ExhibitorSchedule';
import CompanyCard from '@/components/shared/CompanyCard';
import { mapGetters } from 'vuex';
import { db } from '@/services/firebase';

export default {
  props: {
    id: { type: String }
  },
  data() {
    return {
      exhibitorSuites: [],
      filterString: ''
    };
  },
  computed: {
    ...mapGetters(['user']),
    sortedSuites() {
      const newArray = [...this.exhibitorSuites];
      return newArray.sort((a, b) => {
        if (a.company.name.toLowerCase() < b.company.name.toLowerCase()) {
          return -1;
        }
        if (a.company.name.toLowerCase() > b.company.name.toLowerCase()) {
          return 1;
        }
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      });
    },
    filteredSuites() {
      const otherSuites = this.sortedSuites.filter(suite => {
        return !Object.keys(
          this.$store.getters.user.meetings[this.id].suites
        ).includes(suite.id);
      });
      if (this.filterString.length > 0) {
        let lowerFilter = this.filterString.toLowerCase();
        return otherSuites.filter(suite => {
          return (
            suite.name.toLowerCase().includes(lowerFilter) ||
            suite.description.toLowerCase().includes(lowerFilter)
          );
        });
      }
      return otherSuites;
    },
    columnOne() {
      return this.filteredSuites.filter((item, index) => {
        return index % 2 === 0;
      });
    },
    columnTwo() {
      return this.filteredSuites.filter((item, index) => {
        return index % 2 > 0;
      });
    }
  },
  methods: {
    toggleExpanded(suite) {
      suite.expanded = !suite.expanded;
    }
  },
  firestore() {
    const type = this.user.meetings[this.id].type;
    if (type === 'Retailer' || type === 'Supplier') {
      return {
        exhibitorSuites: db
          .collection('meetings')
          .doc(this.id)
          .collection('suites')
          .where('type', '!=', type)
      };
    } else if (type === 'Service Provider') {
      return {
        exhibitorSuites: db
          .collection('meetings')
          .doc(this.id)
          .collection('suites')
      };
    } else {
      return {
        exhibitorSuites: []
      };
    }
  },
  components: {
    ExhibitorSchedule,
    CompanyCard
  }
};
</script>

<style scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/attendees/ViewExhibitors.vue